import { api } from "api";
import {
    createCommonGroup,
    createProduct,
    deleteoptionsGroupById,
    deleteProduct,
    deleteProductOptionById,
    editProduct,
    getAllProducts,
    deleteAllVendorProducts,
} from "api/apiURLs";

export const getProducts = async (params) => {
    const response = await api.get(getAllProducts, { params });
    return response.data;
};

/**
 * Minimal product list for dropdowns. Mirrors getVendorsDropdown — no
 * pagination, just id + title + vendorId + categoryId + available.
 * Use this instead of getProducts() when populating a <select>.
 */
export const getProductsDropdown = async (params = {}) => {
    const response = await api.get("api/products-dropdown", { params });
    return response.data;
};

export const getProductById = async (id) => {
    const response = await api.get(`${getAllProducts}/${id}`);
    return response.data;
};

export const addProduct = async (data) => {
    const response = await api.post(createProduct, data);
    return response.data;
};

export const addExcel = async (data) => {
    const response = await api.post("api/product-excel", data);
    return response.data;
};
export const copyProductsService = async (data) => {
    const response = await api.post("api/product-copy", data);
    return response.data;
};

export const addGroup = async (data) => {
    const response = await api.post(createCommonGroup, data);
    return response.data;
};

export const updateProduct = async (data) => {
    const response = await api.patch(`${editProduct + data.get("id")}`, data);

    return response.data;
};

export const removeProduct = async (id) => {
    const response = await api.delete(`${deleteProduct}${id}`);
    return response.data;
};
export const removeGroup = async (id) => {
    const response = await api.delete(`${deleteoptionsGroupById}${id}`);
    return response.data;
};
export const removeOption = async (id) => {
    const response = await api.delete(`${deleteProductOptionById}${id}`);
    return response.data;
};

export const removeAllVendorProducts = async (vendorId) => {
    const response = await api.delete(`${deleteAllVendorProducts}${vendorId}`);
    return response.data;
};
